module.exports = __webpack_public_path__ + "static/media/judging.4c78c649.png";